'use client';

import { useEffect, useState, type ComponentType } from 'react';
import { useLoadOnVisible } from '@/components/pages/use-load-on-visible';
import { QuoteCarouselServer } from './server';
import type { QuoteCarouselProps } from './type';

export default function LazyQuoteCarouselClient(props: QuoteCarouselProps) {
  const { ref, shouldLoad } = useLoadOnVisible<HTMLDivElement>();
  const [Client, setClient] = useState<ComponentType<QuoteCarouselProps> | null>(null);

  useEffect(() => {
    if (!shouldLoad || Client) return;
    import('./client').then((module) => setClient(() => module.default));
  }, [Client, shouldLoad]);

  return <div ref={ref}>{Client ? <Client {...props} /> : <QuoteCarouselServer {...props} />}</div>;
}
